export type User = {
  id: string;
  email?: string | null;
  role?: string | null;
  email_confirmed_at?: string | null;
  app_metadata?: Record<string, unknown>;
  user_metadata?: Record<string, unknown>;
  identities?: Array<{ provider?: string; [k: string]: unknown }>;
  [k: string]: any;
};

export interface SessionTokens {
  access_token?: string;
  refresh_token?: string;
  expires_at?: number;
}

export const tokenKey = 'bw_auth_tokens';

export function saveTokens(tokens: SessionTokens) {
  try {
    localStorage.setItem(tokenKey, JSON.stringify(tokens));
  } catch (err) {
    // ignore errors writing to localStorage (e.g. SSR, privacy settings)
  }
}

export function loadTokens(): SessionTokens | null {
  try {
    const v = localStorage.getItem(tokenKey);
    return v ? JSON.parse(v) : null;
  } catch (err) {
    // ignore errors reading/parsing localStorage (e.g. SSR or corrupted data)
    return null;
  }
}

export function clearTokens() {
  try {
    localStorage.removeItem(tokenKey);
  } catch (err) {
    // ignore errors removing from localStorage (e.g. SSR, privacy settings)
  }
}
